module.exports = __webpack_public_path__ + "static/q2-8cfd3cb35c0b642d5049e3e517fa826d.png";